import React, { FC, useState } from 'react'
import {
    StyledVolumeControlWrapper,
    StyledVolumeControlTrack,
    StyledVolumeControlHandle,
    StyledVolumeButton,
    StyledIconSpeaker,
} from './VolumeControl.styled'
import { Range } from 'react-range'

export interface VolumeControlProps {
    onChange: (volume: number) => void
    value: number
    className?: string
}

export const VolumeControl: FC<VolumeControlProps> = ({ onChange, value, className }) => {
    const [prevVolume, setPrevVolume] = useState<number | undefined>(undefined)

    const onVolumeButtonClick = () => {
        if (value > 0) {
            setPrevVolume(value)
            onChange(0)
        } else {
            onChange(prevVolume || 0.5)
            setPrevVolume(undefined)
        }
    }

    /**
     * Distils the volume into 3 levels for displaying the correct icon variation [off, half, full]
     * @param value the volume input 0-1
     */
    const getSpeakerVolumeLevel: (value: number) => 1 | 2 | 3 = (value) => {
        if (value === 0) return 1
        if (0 < value && value < 0.5) return 2
        return 3
    }

    const onChangeHandler = (values: number[]) => onChange(values[0])

    return (
        <StyledVolumeControlWrapper className={className}>
            <StyledVolumeButton type="button" onClick={onVolumeButtonClick}>
                <StyledIconSpeaker volume={getSpeakerVolumeLevel(value)} inactive={value === 0} />
            </StyledVolumeButton>
            <Range
                min={0}
                max={1}
                step={0.01}
                onChange={onChangeHandler}
                values={[value]}
                renderTrack={({ props, children }) => (
                    <StyledVolumeControlTrack {...props} style={props.style} value={value}>
                        {children}
                    </StyledVolumeControlTrack>
                )}
                renderThumb={({ props, isDragged }) => (
                    <StyledVolumeControlHandle
                        {...props}
                        style={props.style}
                        isDragged={isDragged}
                    />
                )}
            />
        </StyledVolumeControlWrapper>
    )
}
